<div class="p-4">
    <div class="demo-container">
        <div class="title">HubSpot Target</div>
        <app-hubspot-sandbox-toggle></app-hubspot-sandbox-toggle>
        <div class="text-muted small mt-2">Applies to every HubSpot push on this page.</div>
    </div>

    <div class="demo-container mt-4">
        <div class="title">Job Control Panel</div>
        <select class="form-select" [(ngModel)]="selectedJob" data-testid="scheduled-jobs-selected-job">
            <option *ngFor="let job of jobs" [ngValue]="job">{{ job.label }}</option>
        </select>
        <button 
            type="button" 
            class="btn btn-primary btn-sm ml-2" 
            (click)="runSelectedJob()"
            *ngIf="!( isRunningTransportJobs || isRunningQueueJobs || isRunningCreditCheckJobs || isRunningCollectionsReminder || isRunningDebtorSync || isRunningUSATruck || isRunningFCDataSync || isRunningWinFactorImport || isRunningQuarterlySafetyDocumentRollover )" data-testid="scheduled-jobs-run-job">
            Run Job
        </button>
        <br/>
        <br/>

      <div class="text-primary" role="status" *ngIf=" isRunningTransportJobs || isRunningQueueJobs || isRunningCreditCheckJobs || isRunningCollectionsReminder || isRunningDebtorSync || isRunningUSATruck || isRunningFCDataSync || isRunningWinFactorImport || isRunningQuarterlySafetyDocumentRollover ">
			<i class="fa-solid fa-space-station-moon-construction fa-spin fa-3x"></i>
	    </div>
        <div class="text-primary" role="status" *ngIf="isRunningQueueJobs">
			<i class="fa-solid fa-tree-palm fa-spin fa-3x"></i>
			<i class="fa-solid fa-monkey fa-spin fa-3x"></i>
			<i class="fa-solid fa-banana fa-spin fa-3x"></i>
		</div>
        <div class="text-primary" role="status" *ngIf="isRunningCreditCheckJobs">
		    <i class="fa-regular fa-dice-d20 fa-spin fa-3x"></i>
			<i class="fa-regular fa-dice-d12 fa-spin fa-3x"></i>
			<i class="fa-regular fa-dice-d10 fa-spin fa-3x"></i>
			<i class="fa-regular fa-dice-d8 fa-spin fa-3x"></i>
			<i class="fa-regular fa-dice-d6 fa-spin fa-3x"></i>
		</div>
    </div>
    
    <div class="demo-container mt-4">
        <div class="title">FMCSA Lead Generation</div>
        <div class="fmcsa-lead-row">
            <div class="fmcsa-lead-row__col">
                <div class="mb-3">
                    <label class="form-label mb-1">Add Date</label>
                    <div class="d-flex align-items-center">
                        <input
                            type="date"
                            class="form-control form-control-sm"
                            style="width: 170px;"
                            [(ngModel)]="fmcsaAddDate" data-testid="scheduled-jobs-fmcsa-add-date"/>
                        <button
                            type="button"
                            class="btn btn-primary btn-sm ml-2"
                            (click)="retrieveFMCSAByAddDate()"
                            [disabled]="isRunningFMCSAByAddDateConsole" data-testid="scheduled-jobs-print-to-console">
                            Print to Console
                        </button>
                        <button
                            type="button"
                            class="btn btn-primary btn-sm ml-2"
                            (click)="pushFMCSAByAddDate()"
                            [disabled]="isPushingFMCSA" data-testid="scheduled-jobs-push-to-hub-spot">
                            Push to HubSpot
                        </button>
                    </div>
                    <div class="text-primary mt-2" role="status" *ngIf="isRunningFMCSAByAddDateConsole">
                        <i class="fa-solid fa-truck fa-spin fa-2x"></i>
                        <i class="fa-solid fa-road fa-spin fa-2x"></i>
                        <span class="ms-2">Retrieving carriers from FMCSA...</span>
                    </div>
                </div>
                <div class="mb-3">
                    <label class="form-label mb-1">Window (days)</label>
                    <div class="d-flex align-items-center">
                        <input
                            type="number"
                            min="1"
                            class="form-control form-control-sm"
                            style="width: 100px;"
                            [ngModel]="fmcsaWindowDays"
                            (ngModelChange)="onWindowDaysChange($event)" data-testid="scheduled-jobs-fmcsa-window-days-number"/>
                        <button
                            type="button"
                            class="btn btn-primary btn-sm ml-2"
                            (click)="retrieveFMCSAByWindow()"
                            [disabled]="isRunningFMCSAByWindowConsole" data-testid="scheduled-jobs-print-to-console-retrieve-fmcsaby-window">
                            Print to Console
                        </button>
                        <button
                            type="button"
                            class="btn btn-primary btn-sm ml-2"
                            (click)="pushFMCSAByWindow()"
                            [disabled]="isPushingFMCSA" data-testid="scheduled-jobs-push-to-hub-spot-push-fmcsaby-window">
                            Push to HubSpot
                        </button>
                    </div>
                    <div class="small text-muted mt-1" *ngIf="fmcsaWindowRangeLabel">{{ fmcsaWindowRangeLabel }}</div>
                    <div class="text-primary mt-2" role="status" *ngIf="isRunningFMCSAByWindowConsole">
                        <i class="fa-solid fa-truck fa-spin fa-2x"></i>
                        <i class="fa-solid fa-road fa-spin fa-2x"></i>
                        <span class="ms-2">Retrieving carriers from FMCSA...</span>
                    </div>
                </div>
            </div>

            <div class="fmcsa-lead-row__col fmcsa-audit">
                <div class="fmcsa-audit__row">
                    <div class="fmcsa-audit__controls">
                        <label class="form-label mb-1">Carrier Push Audit</label>
                        <div class="d-flex mb-2">
                            <div class="mr-2">
                                <label class="form-label mb-1 small text-muted">Start</label>
                                <input type="date" class="form-control form-control-sm" style="width: 150px;" [(ngModel)]="auditStartDate" [disabled]="isRunningAudit" data-testid="scheduled-jobs-audit-start-date"/>
                            </div>
                            <div>
                                <label class="form-label mb-1 small text-muted">End</label>
                                <input type="date" class="form-control form-control-sm" style="width: 150px;" [(ngModel)]="auditEndDate" [disabled]="isRunningAudit" data-testid="scheduled-jobs-audit-end-date"/>
                            </div>
                        </div>
                        <button type="button" class="btn btn-primary btn-sm" (click)="runFMCSAAudit()" [disabled]="isRunningAudit" data-testid="scheduled-jobs-run-fmcsaaudit">
                            {{ isRunningAudit ? 'Running…' : 'Run Audit' }}
                        </button>
                        <div class="text-danger small mt-2" *ngIf="auditError">{{ auditError }}</div>
                    </div>

                    <div class="fmcsa-audit__results">
                        <div class="fmcsa-audit__scroll" *ngIf="hasRunAudit && auditRows.length && !auditError">
                            <table class="table table-sm table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th class="text-right">In HubSpot</th>
                                        <th class="text-right">Would Push</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of auditRows">
                                        <td>{{ row.dateLabel }}</td>
                                        <td class="text-right">{{ row.alreadyExists | number }}</td>
                                        <td class="text-right font-weight-bold">{{ row.wouldPush | number }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="text-muted small" *ngIf="!hasRunAudit && !auditError">Pick a date range and run the audit to preview daily push counts.</div>
                        <div class="text-muted small" *ngIf="hasRunAudit && !auditRows.length && !auditError">No carriers found for the selected range.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="demo-container mt-4">
        <div class="title">Quarterly Statements</div>
        <div class="text-muted small mb-2">
            Generates last quarter's Telerik statement and queues the statement email to each invoice receiver. Leave Company ID blank to run every eligible company not already sent one this quarter.
        </div>
        <div class="d-flex align-items-center">
            <input
                type="number"
                min="1"
                class="form-control form-control-sm"
                style="width: 140px;"
                placeholder="Company ID"
                [(ngModel)]="quarterlyStatementCompanyId"
                [disabled]="isQueuingQuarterlyStatements" data-testid="scheduled-jobs-quarterly-statement-company-id"/>
            <button
                type="button"
                class="btn btn-primary btn-sm ml-2"
                (click)="queueQuarterlyStatements()"
                [disabled]="isQueuingQuarterlyStatements" data-testid="scheduled-jobs-queue-quarterly-statements">
                {{ isQueuingQuarterlyStatements ? 'Running…' : 'Queue Statements' }}
            </button>
        </div>
        <div class="small mt-2" *ngIf="quarterlyStatementsResult">{{ quarterlyStatementsResult.message }}</div>
    </div>

    <div class="demo-container mt-4">
        <div class="title">AtoB Fuel Card Sync</div>
        <div class="text-muted small mb-2">
            Pulls the AtoB customer list, refreshes the stored fuel card data, then pushes changed rows onto matching HubSpot Deals.
        </div>
        <div class="d-flex align-items-center">
            <button
                type="button"
                class="btn btn-secondary btn-sm mr-2"
                (click)="runAtoBSync(false)"
                [disabled]="isRunningAtoBSync" data-testid="scheduled-jobs-atob-retrieve-only">
                {{ isRunningAtoBSync ? 'Running…' : 'Retrieve Only' }}
            </button>
            <button
                type="button"
                class="btn btn-primary btn-sm"
                (click)="runAtoBSync(true)"
                [disabled]="isRunningAtoBSync" data-testid="scheduled-jobs-atob-retrieve-and-push">
                {{ isRunningAtoBSync ? 'Running…' : 'Retrieve and Push to HubSpot' }}
            </button>
        </div>

        <div class="text-primary mt-2" role="status" *ngIf="isRunningAtoBSync">
            <i class="fa-regular fa-dice-d20 fa-spin fa-2x"></i>
            <span class="ms-2">Syncing AtoB fuel card data...</span>
        </div>

        <div class="text-danger small mt-2" *ngIf="atoBSyncError">{{ atoBSyncError }}</div>

        <table class="table table-sm mb-0 mt-3" *ngIf="atoBSyncResult && !atoBSyncError">
            <tbody>
                <tr>
                    <td>Customers retrieved</td>
                    <td class="text-right">{{ atoBSyncResult.customersRetrieved | number }}</td>
                </tr>
                <tr>
                    <td>Inserted / updated / unchanged</td>
                    <td class="text-right">
                        {{ atoBSyncResult.inserted | number }} / {{ atoBSyncResult.updated | number }} / {{ atoBSyncResult.unchanged | number }}
                    </td>
                </tr>
                <tr>
                    <td>Skipped (no DOT) / retrieve errors</td>
                    <td class="text-right">{{ atoBSyncResult.skipped | number }} / {{ atoBSyncResult.retrieveErrors | number }}</td>
                </tr>
                <tr>
                    <td>Pending rows</td>
                    <td class="text-right">{{ atoBSyncResult.pendingRows | number }}</td>
                </tr>
                <tr>
                    <td>Deals updated</td>
                    <td class="text-right font-weight-bold">{{ atoBSyncResult.dealsUpdated | number }}</td>
                </tr>
                <tr>
                    <td>No company match / no deal match</td>
                    <td class="text-right">{{ atoBSyncResult.noCompanyMatch | number }} / {{ atoBSyncResult.noDealMatch | number }}</td>
                </tr>
                <tr>
                    <td>Push errors</td>
                    <td class="text-right">{{ atoBSyncResult.pushErrors | number }}</td>
                </tr>
            </tbody>
        </table>
    </div>

</div>



// WEBPACK FOOTER //
// ./src/app/developer/components/developer-tools/scheduled-jobs/scheduled-jobs.component.html